<template>
    <div :style="backgroundColorStyle" class="w-100 h-100">
        <b-overlay spinner-variant="primary" class="w-100 h-100" :show="dataLoading && this.needDiagramJson">
            <div class="w-100 h-100 side-cover" v-show="diagramFound">
                <CustomizedDiagramView ref="diagram_view"
                                       :map-data="map_data"
                                       :img-url="img_url"
                                       :zoom="zoom"
                                       :scale-able="!disableScale && scaleAble"
                                       :image-disable="imageDisable"
                                       :pieces-label-formatter="labelFormatter"
                                       :tooltip-formatter="tooltipFormatter"
                                       @mouseout="whenMouseout"
                                       @pieceClick="handlePieceClick"></CustomizedDiagramView>
                <div class="chart-side" @click="openDataLinePage">
                    <i class="fa-solid fa-chart-line m-auto"></i>
                </div>
            </div>
            <div v-show="diagramFound === false" class="h-100">
                <div class="d-flex flex-column justify-content-center align-items-center h-100">
                    <h3>Unknown Diagram: {{ diagramCode }}</h3>
                    <div>Something went wrong.</div>
                </div>
            </div>
        </b-overlay>
        <b-button class="position-absolute top left float-upon ml-4" variant="outline-primary" v-if="routeDiagramId"
                  @click="backToLastDiagram">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </b-button>
    </div>

</template>

<script>
import CustomizedDiagramView from "@/components/LayoutMaps/openLayers/CustomizedDiagramView";
import {_generateDownloadUrl} from "@/components/LayoutMaps/openLayers/utils/MapUtils";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import VNodeGeneratorMixin from "@/components/LayoutMaps/openLayers/utils/VNodeGeneratorMixin";
import {mapState} from "vuex";

export default {
    name: "CustomizedDiagram",
    components: {CustomizedDiagramView},
    mixins: [emCommonUtilMixin, VNodeGeneratorMixin],
    props: {
        diagramCode: {
            type: String,
            default: ""
        },
        disableScale: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            observer: state => state.customizedDiagram.domResizeObserver,
        }),
        backgroundColorStyle() {
            if (this.hasCode(this.backgroundColor)) {
                return `background-color: ${this.backgroundColor};`;
            }
            return '';
        },
    },
    data() {
        return {
            originPieceDataMap: {},

            zoom: 1,
            scaleAble: true,
            backgroundColor: undefined,
            imageDisable: false,

            map_data: [],
            img_url: '',
            routeDiagramId: null,
            routeStark: [],
            needDiagramJson: true,

            dataLoading: false,
            dataRefresh: null,
            tooltipPopCount: undefined,

            diagramFound: undefined,
        }
    },
    mounted() {
        this.getRemoteData();
        this.dataRefresh = setInterval(() => {
            if (!this.needDiagramJson) {
                this.getRemoteData();
            }
        }, 10000);
    },
    beforeDestroy() {
        if (this.dataRefresh) {
            clearInterval(this.dataRefresh);
        }
        if (this.observer) {
            this.observer.disconnect();
        }
    },
    methods: {
        getRemoteData() {
            let postData = {
                needDiagramJson: this.needDiagramJson,
                tooltipDisplayCountsMap: this.tooltipPopCount
            };
            if (this.routeDiagramId) {
                postData['scdId'] = this.routeDiagramId;
                if (this.needDiagramJson) {
                    this.$refs.diagram_view.cancelScale();
                }
            } else if (this.diagramCode) {
                postData['scdCode'] = this.diagramCode;
            } else {
                return;
            }
            this.dataLoading = true;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_EM_ARCHIVE_URL + "/emSicCustomizedDiagramScd/getDiagramData",
                data: postData,
                commonErrorHandle: false,
                consoleLog: this.needDiagramJson
            }).then(response => {
                if (response) {
                    let object = response.data;
                    this.originPieceDataMap = object.pieceDataMap;
                    this.map_data = this.unpackPieceData(object.pieceDataMap);
                    this.tooltipPopCount = {};//reset count
                    if (this.needDiagramJson) {
                        this.img_url = _generateDownloadUrl(object.imageAttachmentId);
                        let styleJson = {};
                        if (object.styleJson) {
                            styleJson = JSON.parse(object.styleJson);
                            // console.log(styleJson)
                            this.imageDisable = this.hasCode(styleJson.imageDisable) ? styleJson.imageDisable : false;
                            this.zoom = this.hasCode(styleJson.zoom) ? styleJson.zoom : 1;
                            this.scaleAble = this.hasCode(styleJson.scaleAble) ? styleJson.scaleAble : true;
                            this.backgroundColor = styleJson.backgroundColor;
                        }
                        this.$refs.diagram_view.setSomeJson(JSON.parse(object.diagramJson), styleJson.pieceStyle);
                        this.needDiagramJson = false;
                        this.diagramFound = true;
                    }
                }
            }).catch(error => {
                this.diagramFound = false;
                this.needDiagramJson = true;
            }).finally(() => this.dataLoading = false);
        },
        handlePieceClick(event) {
            let name = event.name;
            let piece = this.originPieceDataMap[name];
            if (piece !== undefined) {
                //跳转至其他定制图
                if (piece.routeTo) {
                    if (piece.routeType === 'OTHER_DIAGRAM') {
                        if (this.routeDiagramId) {
                            this.routeStark.push(this.routeDiagramId);//stack
                        }
                        this.toDiagram(piece.routeTo);
                    } else if (piece.routeType === 'ROUTE_URL') {
                        let route = this.$router.resolve(piece.routeTo);
                        window.open(route.href);
                    }
                } else if (Object.keys(piece.popupMap)) {
                    // this.popupStackedLineChart(piece);
                    let popupMap = piece.popupMap;
                    for (let id in popupMap) {
                        let item = popupMap[id];
                        if (item) {
                            switch (item.viewModel) {
                                case 'LINE_CHART':
                                    this._popupToast(this.unpackTextMap(piece.labelMap, ' '),
                                        this._computedStackLineChart(item.relatedId, piece.pieceCode), piece.pieceCode);
                                    break;
                            }
                        }
                    }
                }
            }
        },
        backToLastDiagram() {
            if (this.routeStark.length > 0) {
                this.toDiagram(this.routeStark.pop());
            } else {
                this.toDiagram(null);
            }
        },
        toDiagram(diagramId) {
            this.routeDiagramId = diagramId;
            this.tooltipPopCount = undefined;
            this.needDiagramJson = true;
            this.getRemoteData();
        },
        unpackPieceData(pieceDataMap) {
            let tempList = [];
            for (let id in pieceDataMap) {
                let item = pieceDataMap[id];
                if (item) {
                    let temp = {
                        name: item.pieceCode,
                        value: item.status ? item.status : 0,
                        labelName: this.unpackTextMap(item.labelMap, '\n'),
                        tooltipText: this.unpackTextMap(item.tooltipMap)
                    };
                    tempList.push(temp);
                }
            }
            return tempList;
        },
        unpackTextMap(map, join = '<br>') {
            let tempList = [];
            for (let id in map) {
                if (map[id] && map[id].text) {
                    tempList.push(map[id].text);
                }
            }
            return tempList.join(join)
        },
        //self format
        labelFormatter(item) {
            let target = this.map_data.find(f => f.name === item.name && f.labelName);
            if (target) {
                return '{name|' + target.labelName + '}';
            }
            return '{normalName|' + item.name + '}';
        },
        tooltipFormatter(item) {
            let config = item.data;
            if (config && config.tooltipText) {
                // switch (config.viewModel) {
                //     // case 'TABLE':
                //     //     return this._generateHTMLDom(this._miniTable(data));//todo replace by real data
                //     case 'STRING':
                //     default:
                //         return config.tooltipText;
                // }
                return config.tooltipText;
            }
        },
        whenMouseout(item) {
            if (item.name && this.tooltipPopCount) {
                let count = this.tooltipPopCount[item.name];
                this.tooltipPopCount[item.name] = count ? count + 1 : 1;
            }
        },
        resizeChart() {
            this.$refs.diagram_view.delayResize();
        },

        openDataLinePage() {
            let q = this.$store.state.customizedDiagram.computedHistoryQuery;
            let query = {
                diagramCode: this.diagramCode
            }
            if (q && q.startDate) {
                query.startDate = q.startDate
            }
            let open = this.$router.resolve({
                name: 'dataLineChartsPage',
                query: query
            })
            window.open(open.href);
        },
    }
}
</script>

<style scoped>
.b-overlay-wrap >>> .b-overlay {
    z-index: 9000 !important;
}

.chart-side {
    position: absolute;
    right: 0;
    background-color: rgba(0, 0, 0, 30%);
    color: white;
    width: max-content;
    height: max-content;
    padding: 1rem .5rem;
    border-radius: 3px;
    top: 50%;
    transform: translateX(100%) translateY(-50%);
    transition: transform .3s ease-in-out;
    z-index: 1000;
}

.chart-side:hover {
    background-color: rgba(0, 0, 0, 50%);
}

.chart-side:active {
    background-color: rgba(0, 0, 0, 60%);
}

.side-cover {
    overflow: hidden;
    position: relative;
}

.side-cover:hover .chart-side {
    transform: translateX(0) translateY(-50%) !important;
}
</style>
